<template>
    <!--<img alt="Vue logo" src="./assets/logo.png">-->
    <Home/>
</template>

<script>
    import Home from '@/views/Home';

    export default {
        name: 'App',
        components: {
            Home,
        },
        mounted() {
            document.getElementsByTagName('body')[0].style.setProperty('--text-transition2-color', '#fff');
        }
    }
</script>

<style>
    #app {
        display: flex;
        height: 100%;
    }
</style>
